<template>
  <v-sheet color="grey700" class="py-7 px-8 rounded-0">
    <h4
      class="blue400--text font-weight-bold text-uppercase text-h6"
      v-text="'Skinsback Deposit'"
    />
    <p
      class="text-body-2 blue100--text"
      v-text="'You will be redirected to skinsback.com'"
    />

    <div v-if="bonus" class="mb-3 blue800 blue100--text py-3 d-flex align-center">
      <fai :icon="['fas', 'info-circle']" class="ml-4 text-h6" />
      <p class="lh-1-3 mb-0 font-weight-semibold text-caption px-3">
        <b>+{{ bonus * 100 | toLocale }}% bonus</b> will be applied ON TOP of the total shown on Skinsback
      </p>
    </div>

    <v-btn
      depressed block large tile
      color="green800 green300--text"
      class="font-weight-semibold"
      :ripple="false"
      :loading="loading"
      @click="onClick"
    >
      <fai :icon="['fad', 'external-link-square-alt']" class="green200--text mr-2" />
      Deposit via Skinsback
    </v-btn>
  </v-sheet>
</template>

<script>
import { SKINSBACK_CREATE_ORDER } from '@/utils/constants/api-endpoints'

export default {
  props: {
    close: {
      type: Function,
      required: true,
    },
    payload: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    bonus() {
      return this.payload.bonus ?? 0
    },
  },
  methods: {
    async onClick() {
      if (this.loading) return

      try {
        this.loading = true

        const url = await this.$socket.request(SKINSBACK_CREATE_ORDER)

        try {
          const win = window.open(url, '_blank')
          win.focus()
        } catch (error) {
          throw new Error('Your browser blocked the popup window')
        }

        this.close()
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
